import { stitch } from 'keo';
import { Card, CardText } from 'material-ui/Card';
import { Container } from 'react-grid-system';
import r from 'render-dom';

import umlautShout from 'images/umlaut-shout.png';

const style = {
    container: {
        paddingTop: 70,
        textAlign: 'center',
    },
    image: { maxHeight: 200 },
};

const render = () => (
    r(Container, { style: style.container }, [
        r(Card, [
            r(CardText, [
                r.img({ role: 'presentation', src: umlautShout, style: style.image }),
                r.h2(['Oops. The page you are looking for does not exist.']),
                r.h4(['You may have mistyped the address or the page may have moved.']),
            ]),
        ]),
    ])
);

export default stitch({ render });



// WEBPACK FOOTER //
// ./src/components/public/FourOhFour/index.js